const testimonials = [
  {
    name: "David R.",
    location: "Cool Springs, Franklin, TN",
    rating: 5,
    text: "I'm a VP at a healthcare company in Cool Springs and got called to an emergency board meeting in London with 10 days notice. My passport had expired during COVID and I hadn't thought about it since. Fast Passport Center reviewed my documents within the hour, I shipped everything overnight, and my renewal was back in seven business days. Made my flight out of BNA with two days to spare. Absolutely saved my career moment.",
    service: "Emergency Renewal",
  },
  {
    name: "Sarah & Michael T.",
    location: "Brentwood, TN",
    rating: 5,
    text: "We planned a family trip to Italy — four of us, including two kids who had never had passports. I didn't realize the kids would need in-person acceptance. Fast Passport Center walked us through exactly which Williamson County post office to visit, what forms to bring, and what to do after. Both kids got their passports in eight business days. The whole process was so much less stressful than I expected.",
    service: "Child Passport x2",
  },
  {
    name: "Jennifer M.",
    location: "Spring Hill, TN",
    rating: 5,
    text: "We booked a last-minute Caribbean cruise out of Miami and I realized my passport had only 4 months left — not enough for the cruise line's 6-month requirement. Called Fast Passport Center on a Thursday, had my renewed passport back the following Tuesday. Spring Hill residents — don't wait until the week of your trip like I almost did. These guys are legit.",
    service: "Expedited Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function FranklinTNTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Franklin &amp; Williamson County Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Franklin, Brentwood, and Spring Hill travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}